/* UserAppDataModel */

import { types } from 'mobx-state-tree'

import UserAppDataMDVRModel from "./UserAppDataMDVRModel"


/* Model Properties */
const props = {
    MDVR: types.optional(UserAppDataMDVRModel, {})
}

/* Model Actions */
const actions = (self) => ({})

const UserAppDataModel = types
  .model('UserAppDataModel')
  .props(props)
  .actions(actions)

  export default UserAppDataModel